<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:20:42
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-11 17:08:01
 * @FilePath: \mrc-base-server-view\src\views\data-stored-procedure\add\index.vue
-->
<template>
  <div>
    <data-info @success="success" :loading="loading"></data-info>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { addUpdateProcedure } from '@/service/api/dataStoredProcedure'
import dataInfo from '../modules/index'
export default {
  components: { dataInfo },
  props: {},
  data() {
    return {
      loading: false,
    }
  },
  validations: {},
  computed: {},
  created() {},
  watch: {},
  mounted() {},

  methods: {
    async success(params) {
      this.loading = true
      try {
        const res = await addUpdateProcedure(params)
        if (res.code == 200) {
          this.$Message({
            text: this.$t('message_The_operation_was_successful'),
          })
          this.loading = false
          this.$router.go(-1)
        }
      } catch (err) {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped></style>
